/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import {
  NavLink as RouterLink,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Collapse, List, ListItemButton, Accordion,
} from '@mui/material';
import { ChevronRight, ChevronDown } from 'react-feather';
import _ from 'lodash';

function NavItem({
  href, Icon, title, sub,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const active = false;
  const [open, setOpen] = useState(active);

  const handleClick = () => {
    setOpen(!open);
    navigate(href);
  };

  return (
    <div className="py-2">
      <Accordion
        elevation={0}
        expanded={open}
        onClick={() => {
          handleClick();
        }}
        sx={{
          ...(active && {
            color: 'primary.main',
          }),
        }}
        TransitionProps={{ unmountOnExit: true }}
        className="py-2 px-2 cursor-pointer"
      >
        <div className="flex gap-2">
          {Icon && <Icon />}
          <span>{title}</span>
          {_.size(sub) ? (
            <div>
              {open ? <ChevronDown size="20" /> : <ChevronRight size="20" />}
            </div>
          ) : (
            <></>
          )}
        </div>
      </Accordion>
      {_.size(sub) ? (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {_.map(sub, (item, index) => (
            <div key={index}>
              <List component="div" disablePadding>
                <ListItemButton
                  component={RouterLink}
                  to={item.href}
                  sx={{
                    pl: 6,
                    ...(item.href === location.pathname && {
                      color: 'primary.main',
                      backgroundColor: 'grey.100',
                    }),
                  }}
                >
                  <div className="font-light text-sm">{item.title}</div>
                </ListItemButton>
              </List>
            </div>
          ))}
        </Collapse>
      ) : (
        <></>
      )}
    </div>
  );
}

NavItem.propTypes = {
  href: PropTypes.string,
  Icon: PropTypes.elementType,
  title: PropTypes.string,
};

export default NavItem;
